export default "__VITE_ASSET__31271e28__"